import { createContext } from 'react';

const historicoContext = createContext();

export default historicoContext;